import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PanelLayout from './panel_layout'
import Icon from '../icon'
import Text from '../text'
import Dummy from '../dummy'
import ProfileInfoPanelPlaceholder from '../placeholder/profile_info_panel_placeholder'
import moment from 'moment-mini'

class ProfileInfoPanel extends ImmutablePureComponent {

  render() {
    const { account, noPanel } = this.props

    const Wrapper = noPanel ? Dummy : PanelLayout

    if (!account && !noPanel) {
      return (
        <Wrapper title='About'>
          <ProfileInfoPanelPlaceholder />
        </Wrapper>
      )
    }

    const fields = account.get('fields')
    const content = { __html: account.get('note_emojified') }
    const memberSinceDate = moment(account.get('created_at')).format('MMMM YYYY')
    const hasNote = !!content ? (account.get('note').length > 0 && account.get('note') !== '<p></p>') : false
    const isParody = !!account.get('is_parody')
    const isPro = account.get('is_pro')
    const isDonor = account.get('is_donor')
    const isInvestor = account.get('is_investor')
    const validBadgesCount = [isPro, isDonor, isInvestor, isParody].filter(Boolean).length
    const hasBadges = isPro || isDonor || isInvestor || isParody
    const proBadgeTitle = isPro && account.get('show_pro_life') ? 'PRO Life' : 'PRO'
    const hasManyBadges = validBadgesCount >= 2
    const badges = (
      <>
        {
          isParody &&
          <div className={[_s.mr5, _s.radiusSmall, _s.bgTertiary, _s.py2, _s.px5].join(' ')}>
            <Text weight='bold' size='extraSmall' className={_s.cSecondary} isBadge>PARODY</Text>
          </div>
        }
        { 
          isPro &&
          <div className={[_s.mr5, _s.radiusSmall, _s.bgPro, _s.py2, _s.px5].join(' ')}>
            <Text weight='bold' size='extraSmall' className={_s.colorBGPrimary} isBadge>{proBadgeTitle}</Text>
          </div>
        }
        {
          isInvestor && 
          <div className={[_s.mr5, _s.radiusSmall, _s.bgInvestor, _s.py2, _s.px5].join(' ')}>
            <Text weight='bold' size='extraSmall' className={_s.colorBGPrimary} isBadge>INVESTOR</Text>
          </div>
        }
        {
          isDonor &&
          <div className={[_s.mr5, _s.radiusSmall, _s.bgDonor, _s.py2, _s.px5].join(' ')}>
            <Text weight='bold' size='extraSmall' className={_s.colorBGPrimary} isBadge>DONOR</Text>
          </div>
        }
      </>
    )

    return (
      <Wrapper title='About'>
        <div className={[_s.d].join(' ')}>
          {hasNote && <div className={_s.dangerousContent} dangerouslySetInnerHTML={content} />}

          {
            fields.size > 0 && 
            <div className={[_s.d]}>
              {
                fields.map((pair, i) => (
                  <React.Fragment>
                    <div className={[_s.d, _s.w100PC, _s.my7, _s.borderTop1PX, _s.borderColorSecondary].join(' ')} />
                    <dl className={[_s.d, _s.flexRow, _s.flexWrap, _s.aiCenter].join(' ')} key={`profile-field-${i}`}>
                      <dt
                        className={[_s.text, _s.dangerousContent, _s.lineHeight15, _s.pr5, _s.mrAuto].join(' ')}
                        dangerouslySetInnerHTML={{ __html: pair.get('name_emojified') }}
                        title={pair.get('name')}
                      />
                      <dd
                        className={[_s.dangerousContent, _s.lineHeight15, _s.ml0].join(' ')}
                        title={pair.get('value_plain')}
                        dangerouslySetInnerHTML={{ __html: pair.get('value_emojified') }}
                      />
                    </dl>
                  </React.Fragment>
                ))
              }
            </div>
          }

          {(fields.size > 0 || hasNote) && <div className={[_s.d, _s.w100PC, _s.mb10, _s.mt7, _s.borderTop1PX, _s.borderColorSecondary].join(' ')} /> }
          
          <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.aiCenter].join(' ')}>
            <Icon id='calendar' size='12px' className={_s.cSecondary} />
            <Text color='secondary' size='small' className={_s.ml5}>
              Joined&nbsp;{memberSinceDate}
            </Text>
            {
              hasBadges && !hasManyBadges &&
              <div className={[_s.d, _s.ml10, _s.flexRow, _s.flexWrap, _s.aiCenter].join(' ')}>
                {badges}
              </div>
            }
          </div>
            
          {
            hasBadges && hasManyBadges &&
            <>
              <div className={[_s.d, _s.w100PC, _s.my7, _s.borderTop1PX, _s.borderColorSecondary].join(' ')} />
              <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.aiCenter].join(' ')}>
                {badges}
              </div>
            </>
          }

        </div>
      </Wrapper>
    )
  }
}

ProfileInfoPanel.propTypes = {
  account: ImmutablePropTypes.map,
  noPanel: PropTypes.bool,
}

export default ProfileInfoPanel